import { object, string } from "superstruct";

import RouteNavigator from "@mpa/toolbox/navigation/Navigator";
import Route from "@mpa/toolbox/navigation/Route";

import { loggedInNavigator } from "../../navigation/routes";

export const usersNavigator = loggedInNavigator.addNavigator(
    new RouteNavigator().setPath("/users"),
);
export const usersRoute = usersNavigator.addRoute(new Route());
export const userRoute = usersNavigator.addRoute(
    new Route().setPath("/:user", object({ user: string() })),
);
